import { Dialog, DialogContent, DialogTitle, Popover, Tooltip } from '@mui/material';
import { ColDef, ColumnApi, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';
import _ from 'lodash';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PullToRefresh from 'react-simple-pull-to-refresh';
import { LoadAlertNotifications } from '../../actions';
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from '../../helpers/header.helper';
import setToast from '../../helpers/toaster.helper';
import { AlertsIcon, CancelIcon, EditIcon, ResumeIcon, StopIcon, TrashIcon } from '../../icon';
import { AlertNotificationModel, AlertStatus, ReleaseAlertType } from '../../models/alert.model';
import * as selector from "../../selectors/selectors";
import { AlertNotificationService } from '../../services/AlertNotificationService';
import { UtilityService } from '../../services/UtilityService';
import ConfirmDialog from "../shared/confirm-dialog.component";
import { ActionLabels, GridStatusLabelVariant, ScheduleMessageStatusText, ToasterTexts, appNote, buttonLabels, emptyLabels, pageTitles } from '../shared/constants';
import FilterComponent from '../shared/filters/filter.component';
import { CustomFilterCategory } from '../shared/filters/filter.model';
import GridComponent from "../shared/grid";
import { MenuItemRenderer } from "../shared/grid/actionsMenuItemRendrer";
import { ActionsRenderer } from "../shared/grid/actionsRenderer";
import { HeaderTemplate } from "../shared/grid/grid.services";
import { StatusRenderer } from "../shared/grid/statusRenderer";
import PageHeaderComponent from '../shared/page-header.component';
import { ToasterType } from '../shared/toaster/toaster.model';
import AddAlertsComponent from './add-alerts.component';



interface IProps {
}

const AlertsComponent = (props: IProps) => {
	const dispatch = useDispatch()
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	const AlertNotification: AlertNotificationModel[] = useSelector(selector.alertNotification)
	const [gridApi, setGridApi] = useState<any>()
	const [anchorEl, setAnchorEl] = useState<Element | null>(null)
	const [ShowFilterOptions, setShowFilterOptions] = useState<boolean>(false)
	const [showAddAlert, setShowAddAlert] = useState<boolean>(false)
	const [EditAlertData, setEditAlertData] = useState<AlertNotificationModel>()
	const [editRowId, seteditRowId] = useState<string>("")
	const [ShowAlertDialog, setShowAlertDialog] = useState<boolean>(false)
	const [Show, setShow] = useState<boolean>(false)
	const [ClickRowId, setClickRowId] = useState<string>("")
	const [Text, setText] = useState<string>("")
	const [DialogAction, setDialogAction] = useState<string>("")
	const [ButtonName, setButtonName] = useState<string>("")
	const [IsLoading, setIsLoading] = useState<boolean>(false)
	const [MobileMenu, setMobileMenu] = useState<boolean>(false)
	const [columnApi, setColumnApi] = useState<ColumnApi>(null);
	const [rowData, setRowData] = useState<AlertNotificationModel[]>([]);
	const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
	const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);


	const getGridTitle = () => {
		if (AlertNotification?.length === 1) {
			return "1 Alert"
		}
		else {
			return AlertNotification?.length + " " + pageTitles.ALERTS
		}
	}

	const openAlert = (rowId: string, alert?: AlertNotificationModel) => {
		if (!alert && AlertNotification?.some(row => row.Status === AlertStatus.SCHEDULED)) {
			setShowAddAlert(false);
			setMobileMenu(false);
			setShowAlertDialog(true);
		} else {
			setShowAddAlert(true);
			setEditAlertData(alert);
			seteditRowId(rowId);
			setMobileMenu(false);
			setShowAlertDialog(false);
		}
	}

	const onSearch = (e: any) => {
		gridApi?.setQuickFilter(e.target.value)
	}

	const closeAlert = (isConfim: boolean) => {
		setShowAddAlert(false);
		seteditRowId('');
		setEditAlertData(undefined);
		setMobileMenu(false);
		if (!!isConfim) {
			LoadAlertNotifications(dispatch);
		}
	};



	const AlertsColoumnDefs: ColDef[] = [
		{
			field: "Type",
			headerName: "Type",
			valueGetter: (params: ValueGetterParams) => {
				return params.data.Type === ReleaseAlertType.Release ? "Release" : ""
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },

		},
		{
			field: "Title",
			headerName: "Title",
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },

		},
		{
			field: "Occurrence",
			headerName: "Occurrence",
			hide: IsMobileDevice,
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },

		},
		{
			field: "Status",
			headerName: "Status",
			hide: IsMobileDevice,
			headerComponentParams: {
				template: selectedFilterTypes.includes("Status") ? `${HeaderTemplate.filterApplied(true)}` : ""
			},
			valueGetter: (params: ValueGetterParams) => {
				return params.data.Status === AlertStatus.SCHEDULED ? ScheduleMessageStatusText.SCHEDULED : params.data.Status === AlertStatus.COMPLETED ? "Completed" : ScheduleMessageStatusText.STOPPED
			},
			cellRendererSelector: (params: ICellRendererParams) => {
				if (params.data) {
					const label = params.data.Status === AlertStatus.SCHEDULED ? ScheduleMessageStatusText.SCHEDULED : params.data.Status === AlertStatus.COMPLETED ? "Completed" : ScheduleMessageStatusText.STOPPED

					const Variant = params.data.Status === AlertStatus.SCHEDULED
						? GridStatusLabelVariant.Warning
						: params.data.Status === AlertStatus.COMPLETED
							? GridStatusLabelVariant.Active
							: GridStatusLabelVariant.Danger

					const Status = {
						component: StatusRenderer,
						params: {
							Label: label, Id: params.data.ID, Variant: Variant,
						}
					}
					return Status
				}
				return undefined
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
		},
		{
			field: "StartDateTime",
			headerName: "Scheduled From",
			hide: IsMobileDevice,
			valueGetter: (params: ValueGetterParams) => {
				return UtilityService.convertToDateTimeFormat(params.data.StartDateTime)
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
		},
		{
			field: "EndDateTime",
			headerName: "Scheduled To",
			valueGetter: (params: ValueGetterParams) => {
				return UtilityService.convertToDateTimeFormat(params.data.EndDateTime)
			},
			cellStyle: { textOverflow: 'ellipsis', paddingTop: "15px" },
		},
		{
			field: "Action",
			maxWidth: 40,
			headerName: "",
			pinned: "right",
			lockPinned: true,
			lockPosition: "right",
			cellClass: "ag-cell-actions-style",
			headerClass: "bg-color-secondary",
			cellRenderer: params =>
				<ActionsRenderer
					MenuData={getMenuActions(params.data)}
					{...params}
				/>,
			resizable: false,
			sortable: false,
			hide: IsMobileDevice,
		},
	]

	const openConfirmDialog = (rowId: string, IsDisabled: boolean) => {
		let text = IsDisabled
			? appNote.SCHEDULED_MESSAGE_RESUME
			: appNote.SCHEDULED_MESSAGE_STOP;
		let btnName = IsDisabled ? "Resume" : "Stop";
		setShow(true);
		setClickRowId(rowId);
		setText(text);
		setButtonName(btnName);
		setDialogAction("Stop");
		setMobileMenu(false)
		setIsLoading(false);
	};

	const openDeleteConfirmDialog = (Id: string) => {
		setShow(true);
		setClickRowId(Id);
		setText(appNote.RELEASE_ALERT_DELETE);
		setButtonName("Delete");
		setDialogAction("Delete");
		setMobileMenu(false)
		setIsLoading(false);
	};

	const getMenuActions = (data: AlertNotificationModel) => {
		return [
			{
				Name: ActionLabels.EDIT,
				Icon: EditIcon,
				OnClick: () => { openAlert((data as AlertNotificationModel)?.ID, data) },
				Hide: (data as AlertNotificationModel)?.Status === AlertStatus.COMPLETED,
			},
			{
				Name: data?.Status == AlertStatus.STOPPED ? ActionLabels.RESUME : ActionLabels.STOP,
				Icon: data?.Status == AlertStatus.STOPPED ? ResumeIcon : StopIcon,
				OnClick: () => { openConfirmDialog((data as AlertNotificationModel)?.ID, data?.Status === AlertStatus.STOPPED) },
				Hide: (data as AlertNotificationModel)?.Status === AlertStatus.COMPLETED,
			},
			{
				Name: ActionLabels.DELETE,
				Icon: TrashIcon,
				OnClick: () => {
					openDeleteConfirmDialog(
						(data as AlertNotificationModel)?.ID || ""
					)
				},
			},
		]
	}

	const closeConfirmDialog = (isConfim: boolean) => {
		var action = DialogAction;
		if (!!isConfim) {
			setIsLoading(true);
			var AlertData = AlertNotification.find((x: AlertNotificationModel) => x.ID === ClickRowId)
			let data: any = {
				"id": AlertData?.ID,
				"type": AlertData?.Type,
				"title": AlertData?.Title,
				"subTitle": AlertData?.SubTitle,
				"description": AlertData?.Description,
				"linkType": AlertData?.LinkType,
				"displyText": AlertData?.DisplyText,
				"link": AlertData?.Link,
				"startDateTime": new Date(AlertData?.StartDateTime || "").toISOString(),
				"endDateTime": new Date(AlertData?.EndDateTime || "").toISOString(),
				"occurrence": Number(AlertData?.Occurrence),
				"state": action === "Stop" ? AlertData?.Status === AlertStatus.STOPPED ? AlertStatus.SCHEDULED : AlertStatus.STOPPED : 1,
				"isDeleted": AlertData?.IsDeleted,
			}
			if (action === "Stop" || action === "Resume") {
				AlertNotificationService.stopOrResumeAlertNotification(ClickRowId, data).then(
					() => {
						setShow(false);
						setMobileMenu(false);
						setClickRowId("");
						setIsLoading(false);
						setEditAlertData(undefined);
						setToast(AlertData?.Status === AlertStatus.STOPPED ? ToasterTexts.ALERT_RESUME_SUCCESS.replace('<Name>', AlertData?.Title || '') : ToasterTexts.ALERT_STOPPED_SUCCESS.replace('<Name>', AlertData?.Title || ''), ToasterType.SUCCESS)
						LoadAlertNotifications(dispatch)
					}).catch(err => {
						setToast(AlertData?.Status === AlertStatus.STOPPED ? ToasterTexts.SCHEDULED_MESSAGE_RESUME_SUCCESS.replace("<Name>", AlertData?.Title || "") : ToasterTexts.SCHEDULED_MESSAGE_STOP_SUCCESS.replace("<Name>", AlertData?.Title || ""), ToasterType.SUCCESS);
					})
			}
			else {
				AlertNotificationService.deleteAlertNotification(ClickRowId).then((res) => {
					setShow(false);
					setMobileMenu(false);
					setClickRowId("");
					setIsLoading(false);
					setEditAlertData(undefined);
					setToast(ToasterTexts.ALERT_DELETE_SUCCESS.replace("<Name>", AlertData?.Title || ''), ToasterType.SUCCESS)
					LoadAlertNotifications(dispatch)
				}).catch(err => {
					setToast(
						ToasterTexts.ALERT_DELETE_FAILED.replace("<Name>", (AlertData as AlertNotificationModel)?.Title), ToasterType.SUCCESS)
				})
			}
		}
		else {
			setShow(false);
			setMobileMenu(false);
			setClickRowId("");
			setIsLoading(false);
			setEditAlertData(undefined);;
		}
	};

	const closeAlertDialog = () => {
		setShowAddAlert(false);
		setMobileMenu(false);
		setShowAlertDialog(false);
	}

	const onGridReady = (params) => {
		setGridApi(params.api)
		setColumnApi(params.columnApi)
	}

	useEffect(() => {
		if (!AlertNotification || AlertNotification.length === 0) {
			LoadAlertNotifications(dispatch);
		}
	}, []);

	useEffect(() => {
		setHeaderTitle(pageTitles.ALERTS);
		setHeaderCount(AlertNotification?.length || 0)
		setRefreshHandler(gridRefresh)
		return setHeaderTitle
	}, [gridApi, columnApi])


	const gridRefresh = () => {
		LoadAlertNotifications(dispatch);
		if (!!columnApi) {
			columnApi?.resetColumnState()
		}
		if (!!gridApi) {
			gridApi?.refreshCells({ force: true })
		}
		gridApi?.deselectAll();
	}

	const CloseMobileMenu = () => {
		setMobileMenu(false);
		setEditAlertData(undefined);
	};

	const handleRowClick = (row: AlertNotificationModel) => {
		if (IsMobileDevice) {
			setMobileMenu(true);
			setEditAlertData(row);
		}
	}

	useEffect(() => {
		setRowData(AlertNotification)
		setHeaderCount(AlertNotification?.length || 0)
	}, [AlertNotification])
	const initialFilterOptions = () => {
		const filterData: CustomFilterCategory[] = [
			{
				Id: 1,
				Title: "Status",
				IsSelectedAll: false,
				Options: _(rowData).map((row) => {
					return {
						Key: "Status",
						Id: row.ID,
						Label: row.Status === AlertStatus.SCHEDULED ? ScheduleMessageStatusText.SCHEDULED : row.Status === AlertStatus.COMPLETED ? "Completed" : ScheduleMessageStatusText.STOPPED,
						Value: row.Status as any,
						IsSelected: false,
					}
				})
					.unionBy("Label")
					.value(),
			}
		]
		setFilterOptions(filterData)
	}

	useEffect(() => {
		initialFilterOptions()
	}, [rowData])

	const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (IsMobileDevice) {
			setShowFilterOptions(true);
		}
		else {
			setAnchorEl(event.currentTarget)
		}
	}

	const handleCloseFilter = () => {
		setAnchorEl(null);
		setShowFilterOptions(false);
	}

	const handleApplyFilters = (filters) => {
		setFilterOptions(filters);
		const { result } = UtilityService.getFilterTypes(filters);
		setSelectedFilterTypes(result)
	};

	const pullToRefresh = () =>
		new Promise((resolve) => setTimeout(resolve, 15)).then(() => LoadAlertNotifications(dispatch));

	return (
		showAddAlert && IsMobileDevice ?
			<AddAlertsComponent
				ShowAddAlert={showAddAlert}
				OnClose={closeAlert}
				AlertData={EditAlertData}
				rowId={editRowId}
			/>
			:
			<PullToRefresh isPullable={IsMobileDevice} pullingContent="" onRefresh={pullToRefresh} >
				<div className="d-flex flex-direction h-p-100 o-hidden justify-between">
					<PageHeaderComponent
						Reload={() => LoadAlertNotifications(dispatch)}
						GridTitle={""}
						Count={AlertNotification.length}
						Actions={[
							{
								OnClick: () => openAlert("", undefined),
								ButtonLabel:
									buttonLabels.ADD_ALERT,
								Icon: AlertsIcon,
								Variant: "primary-btn",
								ClassName: "mr-2"
							},
						]}
						onSearch={onSearch}
						PlaceHolder={"Find ..."}
						ShowFilterIcon={true}
						IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
						HandleFilter={handleClickFilter}
					/>
					<GridComponent
						ColumnDefs={AlertsColoumnDefs}
						RowData={rowData}
						OnGridReady={onGridReady}
						IsPaginationEnabled={IsMobileDevice ? false : true}
						EmptyLabel={emptyLabels.ALERTS}
						LockVisible={IsMobileDevice}
						OnGridRowClick={handleRowClick}
						filterOptions={filterOptions}
						IsFilterPresent={true}
						gridApi={gridApi}
					/>

					{showAddAlert &&
						(<AddAlertsComponent
							ShowAddAlert={showAddAlert}
							OnClose={closeAlert}
							AlertData={EditAlertData}
							rowId={editRowId}
						/>)
					}

					{Show && (
						<ConfirmDialog
							onClose={closeConfirmDialog}
							Show={Show}
							Text={Text}
							ButtonName={ButtonName}
							IsMobileDevice={IsMobileDevice}
							Loading={IsLoading}
						/>
					)}

					{ShowAlertDialog && (
						<ConfirmDialog
							onClose={closeAlertDialog}
							HideCancel
							Show={ShowAlertDialog}
							Text={appNote.ALERT_DIALG_TEXT}
							ButtonName={buttonLabels.OK}
							IsMobileDevice={IsMobileDevice}
							Loading={IsLoading}
							Title={"Alert"}
						/>
					)}

					{!IsMobileDevice && Boolean(anchorEl) &&
						<Popover
							open={Boolean(anchorEl)}
							anchorEl={anchorEl}
							onClose={handleCloseFilter}
							anchorOrigin={{
								vertical: 'top',
								horizontal: 'right',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}}
							classes={{ paper: `min-w-40` }}
						// BackdropProps={{
						// 	invisible: true,
						// 	onClick: (event) => event.stopPropagation(),
						// }}
						>
							<FilterComponent
								Filters={filterOptions}
								HandleApplyFilters={handleApplyFilters}
								OnClose={handleCloseFilter}
							/>
						</Popover>
					}

					{
						IsMobileDevice && MobileMenu &&
						<Dialog
							fullWidth
							onClose={CloseMobileMenu}
							aria-labelledby="responsive-dialog-title"
							open={true}
							BackdropProps={{ style: { backgroundColor: "transparent" } }}
							classes={{ paper: "br-1 dialogue-shadow w-p-70 bg-color-menu-bg" }}
						>
							<DialogTitle className="dialog-header">
								<div className="h1 d-flex" id="customized-dialog-title">
									{EditAlertData != undefined &&
										EditAlertData?.Title}
									<Tooltip title="Close" placement="bottom">
										<span className="ml-auto">
											<CancelIcon
												className={"c-pointer"}
												onClick={(e: any) => {
													e.stopPropagation();
													CloseMobileMenu();
												}}
											/>
										</span>
									</Tooltip>
								</div>
							</DialogTitle>
							<DialogContent className={"mln-1 o-hidden pt-0"}>
								<MenuItemRenderer MenuData={getMenuActions(EditAlertData)} OnClick={CloseMobileMenu} />
							</DialogContent>
						</Dialog>
					}
				</div>
			</PullToRefresh>
	)
}

export default AlertsComponent;